import IResponseSave from '../models/IResponseSave';
import ApiReceiver from '@/api/ApiReceiver';
import PostCommand from '@/api/PostCommand';
import GetCommand from '@/api/GetCommand';
import RetryManager from '@/api/RetryManager';
import IApiCommand from '@/api/IApiCommand';

class ResponseApiController {
  private readonly retryManager: RetryManager = new RetryManager();
  private readonly apiReceiver: ApiReceiver = new ApiReceiver();

  private readonly RESPONSE_PATH: string;
  private readonly POST_ENDPOINT = 'qti-response';
  private readonly GET_ENDPOINT = 'qti-responses/';

  constructor(baseServiceUrl: string | undefined) {
    this.RESPONSE_PATH = `${baseServiceUrl}/qti-player/api/`;
  }

  createPersistenceCommand(responseData: IResponseSave): IApiCommand<IResponseSave> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    return new PostCommand<IResponseSave>(
      that.apiReceiver,
      that.RESPONSE_PATH + that.POST_ENDPOINT,
      JSON.parse(JSON.stringify(responseData)),
      'response'
    );
  }

  getResponses<T = never>(qtiSessionId: string): Promise<T | null> {
    return this.retryManager.runCommand(
      new GetCommand<T>(this.apiReceiver, this.RESPONSE_PATH + this.GET_ENDPOINT + qtiSessionId)
    );
  }
}

export default ResponseApiController;
